/*
 * VintageFilm — global film overlay: heavy grain, drifting scratches,
 * flicker, frame jitter, plus an SVG turbulence filter that .deco-text
 * elements use to wobble like projected celluloid.
 */
export default function VintageFilm() {
  return (
    <>
      {/* Off-screen SVG holding the text grain/wobble filter referenced by .deco-text */}
      <svg
        width="0"
        height="0"
        style={{ position: "absolute", width: 0, height: 0 }}
        aria-hidden
      >
        <filter id="filmGrainText" x="-5%" y="-5%" width="110%" height="110%">
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.82"
            numOctaves="2"
            seed="7"
            result="noise"
          >
            <animate
              attributeName="seed"
              values="1;3;5;7;9;11;13"
              dur="0.6s"
              repeatCount="indefinite"
            />
          </feTurbulence>
          <feDisplacementMap in="SourceGraphic" in2="noise" scale="1.2" />
        </filter>
      </svg>

      <div className="vintage-film" aria-hidden>
        <div className="vintage-film-flicker" />
        <div className="vintage-film-grain" />
        <div className="vintage-film-grain heavy" />
        <div className="vintage-film-scratches" />
        <div className="vintage-film-dust" />
      </div>
    </>
  );
}
